import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Block } from "./Block";
import { BlocksDispenser } from "./BlocksDispenser";
import { GridContainer } from "./GridContainer";
import { SpecialCell } from "./SpecialCell";
import * as Templok from "@ravalmatic/templok-engine";

export class BoardContainer extends Phaser.GameObjects.Container {

    public static readonly CELL_SIZE = 77.8;

    public static currentInstance: BoardContainer;

    public blocksDispenser: BlocksDispenser;
    public gridContainer: GridContainer;
    public specialCellTrackContainer: Phaser.GameObjects.Container;

    private specialCells: SpecialCell[];

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        BoardContainer.currentInstance = this;

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT * .45;
        
        this.scaleY = GameVars.scaleY;

        this.specialCells = [];

        this.gridContainer = new GridContainer(this.scene);
        this.add(this.gridContainer);

        this.blocksDispenser = new BlocksDispenser(this.scene);
        this.add(this.blocksDispenser);

        this.specialCellTrackContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(this.specialCellTrackContainer);
    }

    public update(): void {
       
        this.blocksDispenser.update();
        this.gridContainer.update();

        this.specialCells.forEach(function(specialCell: SpecialCell): void {
            specialCell.update();
        });
    }

    public onGameStarted(): void {

        this.gridContainer.onGameStarted();
        this.blocksDispenser.onGameStarted();
    }

    public addSpecialCell(p: {c: number, r: number}, specialCellType: number, i: number, n: number): void {

        const specialCell = new SpecialCell(this.scene, p, specialCellType, i, n);
        this.add(specialCell);

        this.specialCells.push(specialCell);
    }

    public removeSpecialCell(specialCell: SpecialCell): void {
        
        const i = this.specialCells.indexOf(specialCell);

        if (i !== -1) {
            this.specialCells.splice(i, 1);
        }
    }
   
    public addBlock(block: Block, p: {c: number, r: number}): void {

        this.gridContainer.addBlock(block, p);

        this.blocksDispenser.onBlockAddedToGrid(block);
    }

    public spawnBlock(blockData: Templok.BlockData): void {

        this.blocksDispenser.spawnBlock(blockData);
    }

    public moveBlockToNiche(block: Block): void {

        this.blocksDispenser.moveBlockToNiche(block);

        this.unMarkDropPosition();
    }

    public returnToOrigin(block: Block, droppedOutsideBoard: boolean): void {

        this.blocksDispenser.returnToOrigin(block, droppedOutsideBoard);
    }

    public reRoll(blockData: Templok.BlockData): void {

        this.blocksDispenser.niche.reRoll(blockData);
    }

    public onMatch(lines: number[], columns: number[], duplicatedCellsData: {p: {c: number, r: number}, type: number}[]): void {

        this.gridContainer.onMatch(lines, columns, duplicatedCellsData);
    }
    
    public markDropPosition(p: {c: number, r: number}, blockData: Templok.BlockData): void {

        this.gridContainer.markDropPosition(p, blockData);
    }

    public unMarkDropPosition(): void {
        
        this.gridContainer.unMarkDropPosition();
    }

    public markShadows(p: {c: number, r: number}, blockData: Templok.BlockData): void {
        
        this.gridContainer.markShadows(p, blockData);
    }

    public unMarkShadows(): void {
        
        this.gridContainer.unMarkShadows();
    }

    public markPossibleLinesAndColumns(lines: number[], columns: number[], duplicatedCells: {p: {c: number, r: number}, type: number}[]): void {

        this.gridContainer.markPossibleLinesAndColumns(lines, columns, duplicatedCells);
    }

    public unMarkPossibleLinesAndColumns(): void {

        this.gridContainer.unMarkPossibleLinesAndColumns();
    }

    public onGameOver(): void {

        this.gridContainer.onGameOver();
        this.blocksDispenser.removeHandCursor();
    }
}
